import { useKeycloak } from "@react-keycloak/web";
import { useEffect, useState } from "react";
import { environment } from "../environment";
import { USER_ROLES } from "../models/user.model";
import { useAxios } from "./useAxios";
import { SetMerchantArrayForAllUsers, UserManagementMerhantIdToName } from "../utils/userManagment.util";
import { useUserValidationContext } from "../context/user-validating.context";

export const useUser = () => {
  const [securityInfoData, SetSecuritInfoData] = useState({});
  const [companyName, setCompanyName] = useState("");
  const [merchantId, setMerchantId] = useState("");
  const [merchantName, setMerchantName] = useState("");

  const [merchantInfo, setMerchantInfo] = useState([]);
  const [merchantArray, setMerchantArray] = useState([]);

  const [merchantNameAndId, setMerchandNameAndId] = useState([]);

  const [selectedMerchant, setSelectedMerchant] = useState("");

  //STATE FOR GLOBAL USER ADMIN
  const [isGlobalUserAdminState, setIsGlobalUserAdminState] = useState(false);

  //USER ROLES FOR DISPLAY
  const [userRoles, setUserRoles] = useState([]);

  const { initialized } = useKeycloak();
  const { axiosInstance } = useAxios();
  const { setIsValidating } = useUserValidationContext()

  const getDashboardUserValidateEndpoint = () => {
    //FETCH MERCHANTS
    const url = `${process.env.REACT_APP_MANAGEMENT_BACKEND_URL}${environment.getDashboardUserValidateMethod}`;

    axiosInstance?.current
      ?.get(url)
      .then((res) => {
        /*
            {
              "keycloakId": "string",
              "keycloakRealm": "string",
              "userType": "string",
              "joinedOn": "2023-08-22T15:45:04.597Z",
              "merchantInfo": [
                {
                  "userId": "3fa85f64-5717-4562-b3fc-2c963f66afa6",
                  "merchantId": "3fa85f64-5717-4562-b3fc-2c963f66afa6",
                  "role": "string"
                }
              ]
            }
            */

        const merchantInfo = res.data?.merchantInfo || [];
        const merchantId = merchantInfo[0]?.merchantId;

        //SET CURRENT MERCHANT ID
        setMerchantId(merchantId);
        setMerchantInfo(merchantInfo);
        if (merchantInfo[0]?.merchantName !== "") {
          setSelectedMerchant(merchantInfo[0]?.merchantName);
        }

        setIsValidating(false) // STOP THE MAIN APP LOADER!!!
      })
      .catch((err) => {
        setIsValidating(false) // STOP THE MAIN APP LOADER!!!
        console.log(err);
      });
  };
  
  useEffect(() => {
    if (initialized) {
      //GET FROM OUR BACKEND, CALLED ONLY ONCE
      getDashboardUserValidateEndpoint();
    }
  }, [initialized]);

  //GET MERCHANTS ONLY FOR GLOBAL ADMIN
  const getSuperAdminMerchants = () => {
    let url = `${process.env.REACT_APP_MANAGEMENT_BACKEND_URL}${environment.getSuperAdminMerchantsMethod}`;

    axiosInstance?.current
      ?.get(url)
      .then((res) => {
        const merchantData = res?.data || [];

        //SET MERCHANT ARRAY FOR FILTER AND DROPDOWN
        setMerchantArray(merchantData.map((merchants) => merchants?.merchantName));
        //SET MERCHANT ARRAY OBJECTS FOR CHANGING ID TO NAME
        setMerchandNameAndId(merchantData);
        console.log("MERCHANT ARRAY => ", merchantArray);

        setMerchantName(UserManagementMerhantIdToName(merchantId, merchantData));
      })
      .catch((err) => {
        console.log("Nekaj je poslo po zlu :3 => ", err);
      });
  };

  useEffect(() => {
    console.log("MERCHANT ARRAY => ", merchantArray);
  }, [merchantArray]);

  //SET MERCHANTS FOR ALL TYPES OF USERS EXCEPT GLOBAL ADMIN TROUGH THE MERCHANTINFO
  const setMerchantArrayForAllUsers = () => {
    setMerchantArray(SetMerchantArrayForAllUsers(merchantInfo));
  };

  //IMPORTANT TO SEE IF THE USER IS GLOBAL ADMIN OR NOT
  useEffect(() => {
    console.log("MERCHANT ARRAY CHECK IS GLOBAL USER ADMIN => ", isGlobalUserAdmin);
    if (isGlobalUserAdmin) {
      getSuperAdminMerchants();
    } else {
      setMerchantArrayForAllUsers();
    }
  }, [userRoles]);

  //GET USER DATA from OLD JAVA BACKEND (This has to be replaced in future with NEW BACKEND endpoint)
  /**
   * @deprecated This has to be replaced in future with NEW BACKEND endpoint
   * @returns USER data from OLD JAVA BACKEND aka "Reporter Backend"
   */
  const getSecurityInfoData = () =>
    axiosInstance?.current
      ?.get(environment.securityInfoEndpoint)
      .then((res) => {
        const responseData = res.data?.data;
        const companyName =
          responseData?.account?.accountData?.companyData?.companyName || responseData?.owner?.name || responseData?.owner?.externalId;

        SetSecuritInfoData(res);

        //SET FROM OUR BACKEND
        setCompanyName(companyName);
      })
      .catch((err) => console.log("getSecurityInfoData [ERROR] => ", err));

  useEffect(() => {
    console.log("Is TEST User Roles:", userRoles, { merchantInfo });
    console.log("Is TEST Super User:", isGlobalUserAdmin);
    console.log("Is TEST UserAdmin:", isUserAdmin);
    console.log("Is TEST User:", isUser);
    console.log("Is TEST Analyst:", isAnalyst);
    console.log("Is TEST Device Manager:", isDeviceManager);
    console.log("Is TEST Campaign Manager:", isCampaignManager);
    console.log("Is TEST POS Manager:", isPOSManager);
  }, [userRoles.length]);

  useEffect(() => {
    //EXTRACT USER ROLES FROM CURRENT LOGGED IN MERCHANT
    // Default Role is USER (if not set in Merchant Info)
    if (!isGlobalUserAdminState) {
      const selectedMerchants = merchantInfo.filter((merchant) => merchant.merchantName === selectedMerchant).find((id) => id.merchantId);
      setMerchantId(selectedMerchants?.merchantId);
      const roles = merchantInfo?.filter((merchant) => merchant.merchantId === merchantId).map((role) => role.role) || [USER_ROLES.Viewer];
      setIsGlobalUserAdminState(roles.includes(USER_ROLES.GlobalUserAdmin));
      setUserRoles(roles);
    } else {
      const selectedMerchants = merchantNameAndId.filter((merchant) => merchant.merchantName === selectedMerchant).find((id) => id.merchantId);
      setMerchantId(selectedMerchants?.merchantId);
      setUserRoles(["Super Admin"]);
    }
  }, [selectedMerchant, merchantId]);

  //CALCULATE CURRENT ROLES from MerchantInfo
  const isGlobalUserAdmin = userRoles.includes(USER_ROLES.GlobalUserAdmin);
  //const isGlobalUserAdmin = true
  const isUserAdmin = userRoles.includes(USER_ROLES.UserAdmin);
  //const isUserAdmin = true
  const isCampaignManager = userRoles.includes(USER_ROLES.CampaignsManager);
  const isUser = userRoles.includes(USER_ROLES.Viewer);
  const isAnalyst = userRoles.includes(USER_ROLES.Accountant);
  const isDeviceManager = userRoles.includes(USER_ROLES.DeviceManager);
  const isPOSManager = userRoles.includes(USER_ROLES.POSManager);

  // APPLY RESTRICTIONS BY ROLES TO FUNCTIONALITIES => https://smarcom.atlassian.net/wiki/spaces/SMAR23/pages/161021953/Dashboard+User+Rights
  // if environment.USER_ROLE_MANAGEMENT_FEATURE is DISABLED all is TRUE (off)
  const roleCanExport = environment.USER_ROLE_MANAGEMENT_FEATURE
    ? userRoles.some((role) =>
        [USER_ROLES.GlobalUserAdmin, USER_ROLES.UserAdmin, USER_ROLES.CampaignsManager, USER_ROLES.Accountant, USER_ROLES.DeviceManager].includes(
          role
        )
      )
    : true;
  const roleCanManageMoney = userRoles.some((role) => [USER_ROLES.GlobalUserAdmin, USER_ROLES.UserAdmin, USER_ROLES.Accountant].includes(role));
  const roleCanManageCampaigns = userRoles.some((role) =>
    [USER_ROLES.GlobalUserAdmin, USER_ROLES.UserAdmin, USER_ROLES.CampaignsManager].includes(role)
  );

  const roleCanViewDeviceSetup = userRoles.some((role) =>
    [USER_ROLES.GlobalUserAdmin, USER_ROLES.UserAdmin, USER_ROLES.DeviceManager].includes(role)
  );

  const roleCanManageDevices = userRoles.some((role) => [USER_ROLES.GlobalUserAdmin, USER_ROLES.UserAdmin, USER_ROLES.DeviceManager].includes(role));

  const roleCanManagePOSDevices = userRoles.some((role) => [USER_ROLES.GlobalUserAdmin, USER_ROLES.UserAdmin, USER_ROLES.POSManager].includes(role));

  return {
    securityInfoData,
    companyName,

    userRoles,

    merchantId,
    setMerchantId,
    merchantInfo,
    merchantName,
    merchantNameAndId,
    merchantArray,
    setSelectedMerchant,
    selectedMerchant,

    isGlobalUserAdmin,
    isUserAdmin,
    isCampaignManager,
    isUser,
    isAnalyst,
    isDeviceManager,
    isPOSManager,

    //RESTRICTIONS
    roleCanExport,
    roleCanManageMoney,
    roleCanManageCampaigns,
    roleCanViewDeviceSetup,
    roleCanManageDevices,
    roleCanManagePOSDevices,
  };
};
